import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { CollapsibleSection } from "components/designV2/collapsibleSection/collapsibleSection";
import { useTranslation } from "react-i18next";
import { GigType, type CompanyGig } from "model/Gig";
import { TeamPublicDetailsModalEditSection } from "./teamPublicDetailsModal.editSection.component";
import { TeamPublicDetailsModalDetailsSection } from "./teamPublicDetailsModal.detailsSection.component";
import type {
  TeamPublicDetailsEditActions,
  TeamPublicDetailsEditViewState,
} from "./teamPublicDetailsModal.contract";
import { GigDetailsContent } from "./teamPublicDetailsModal.styled";
import {
  DetailsLoader,
  DetailsMessage,
  DetailsSpinner,
  EditActions,
  EditFooterRow,
} from "../shiftDetailsModal.styled";

interface TeamPublicDetailsModalGigSectionProps {
  selectedShiftGigType: GigType | undefined;
  isLoading: boolean;
  isError: boolean;
  gigData: CompanyGig | null;
  paymentTypeLabel: string;
  skillsLabel: string;
  editViewState: TeamPublicDetailsEditViewState;
  editActions: TeamPublicDetailsEditActions;
}

export const TeamPublicDetailsModalGigSection: React.FC<
  TeamPublicDetailsModalGigSectionProps
> = (props) => {
  const { t } = useTranslation();
  const isPublicShift = props.selectedShiftGigType === GigType.PUBLIC;

  return (
    <CollapsibleSection
      label={t("Schedule.TeamPublicDetailsTitle")}
      defaultOpen
    >
      {props.isLoading ? (
        <DetailsLoader>
          <DetailsSpinner />
        </DetailsLoader>
      ) : props.isError || !props.gigData ? (
        <DetailsMessage>{t("Schedule.ShiftDetailsNotFound")}</DetailsMessage>
      ) : (
        <GigDetailsContent>
          {props.editViewState.isEditing ? (
            <TeamPublicDetailsModalEditSection
              isPublicShift={isPublicShift}
              editViewState={props.editViewState}
              editActions={props.editActions}
            />
          ) : (
            <TeamPublicDetailsModalDetailsSection
              gigData={props.gigData}
              isPublicShift={isPublicShift}
              paymentTypeLabel={props.paymentTypeLabel}
              skillsLabel={props.skillsLabel}
            />
          )}
          {props.editViewState.isEditing && (
            <EditFooterRow>
              <div />
              <EditActions>
                <SecondaryButton
                  size="small"
                  label={t("General.Cancel")}
                  onClick={props.editActions.handleCancelEdit}
                  disabled={props.editViewState.isSaving}
                />
                <PrimaryButton
                  size="small"
                  label={t("General.Save")}
                  onClick={props.editActions.handleSaveEdit}
                  isLoading={props.editViewState.isSaving}
                />
              </EditActions>
            </EditFooterRow>
          )}
          {props.editViewState.saveError && (
            <DetailsMessage>{props.editViewState.saveError}</DetailsMessage>
          )}
        </GigDetailsContent>
      )}
    </CollapsibleSection>
  );
};
